import { useId } from 'react';

/**
 * **Le choix de fichiers à déposer.**
 *
 * `CDC-3` F-34 : « **on dépose plusieurs fichiers d'un coup**, par sélection multiple ou
 * glisser-déposer. **Le dépôt d'un dossier entier avec son arborescence n'est pas au
 * périmètre.** » L'attribut `multiple` porte la première moitié ; l'absence de
 * `webkitdirectory` porte la seconde, et c'est une absence délibérée.
 *
 * **Le bouton natif du navigateur est habillé, pas remplacé.** Un composant maison
 * demanderait de piloter un champ caché depuis un bouton, ce qui casse le clavier, le
 * tactile et l'annonce du nombre de fichiers choisis — pour un gain d'apparence sur un
 * élément qu'on voit deux secondes.
 *
 * **Aucune borne de taille n'est posée ici** (F-34) : « **aucune taille maximum par
 * fichier** : seul le plafond de l'espace borne ». Une borne d'interface ferait refuser
 * localement ce que le produit accepte, et elle divergerait du vrai plafond.
 */
type Props = {
  readonly libelle: string;
  readonly aide?: string;
  readonly onChoisir: (fichiers: readonly File[]) => void;
};

export function ChoixDeFichiers({ libelle, aide, onChoisir }: Props) {
  const base = useId();
  const idAide = aide === undefined ? undefined : `${base}-aide`;

  return (
    <div className="flex flex-col gap-1">
      <label
        htmlFor={base}
        className="text-14 font-weight-700 text-texte-fort"
      >
        {libelle}
      </label>
      <input
        id={base}
        type="file"
        multiple
        aria-describedby={idAide}
        onChange={(evenement) => onChoisir([...(evenement.target.files ?? [])])}
        className={[
          'text-14 text-texte',
          'file:mr-3 file:min-h-cible file:rounded-2 file:border-0',
          'file:bg-action-douce-fond file:px-3',
          'file:text-14 file:font-weight-700 file:text-action-douce-texte',
          'focus-visible:outline focus-visible:outline-2',
          'focus-visible:outline-offset-2 focus-visible:outline-focus',
        ].join(' ')}
      />
      {aide !== undefined && (
        <p id={idAide} className="text-13 text-texte-faible">
          {aide}
        </p>
      )}
    </div>
  );
}
